export default {
    wechatRedirect:'/api/wechat/redirect?url=http%3A%2F%2Fjsrq.hzszjh.com%2F%23%2Findex&scope=snsapi_userinfo',
    LookCustforBind:'/api/wechat/LookCustforBind',
    WeiXinBind:'/api/wechat/WeiXinBind',
    LookCustByOpenID:'/api/wechat/LookCustByOpenID',
    WeiXinUnBind:'/api/wechat/WeiXinUnBind',
    LookFeeAllByWX:'/api/wechat/LookFeeAllByWX',
    LookTradeByWX:'/api/wechat/LookTradeByWX',
    LookOweAll:'/api/wechat/LookOweAll',
    LookAccountDetail:'/api/wechat/LookAccountDetail',
    AccountDetailOrder:'/api/wechat/AccountDetailOrder',
    searchOrder:'/api/wechat/searchOrder',
    PayADSus:'/api/wechat/PayADSus',
    PayADFail:'/api/wechat/PayADFail',
    SearchAccountDetail:'/api/wechat/SearchAccountDetail',
    CheckAccountDetail:'/api/wechat/CheckAccountDetail',
    LookOweListByWX:'/api/wechat/LookOweListByWX',
    CheckFeeAll:'/api/wechat/CheckFeeAll',
    FeeAllOrder:'/api/wechat/FeeAllOrder',
    weChatConfig:'/api/wechat/jssdk',
    LookPreMoneyLeft:'/api/wechat/LookPreMoneyLeft',
    PreMoneyOrder:'/api/wechat/PreMoneyOrder',
    LookPreMoneyList:'/api/wechat/LookPreMoneyList',
    LookUserDayGas:'/api/wechat/LookUserDayGas',
    LookUserMonthGas:'/api/wechat/LookUserMonthGas',

    LookWorkDone:'/api/wechat/LookWorkDone',
}